import { render, staticRenderFns } from "./ModalDelete.vue?vue&type=template&id=d813f19a&scoped=true&"
import script from "./ModalDelete.vue?vue&type=script&lang=js&"
export * from "./ModalDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalDelete.vue?vue&type=style&index=0&id=d813f19a&prod&lang=scss&"
import style1 from "./ModalDelete.vue?vue&type=style&index=1&id=d813f19a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d813f19a",
  null
  
)

export default component.exports